import { createIntl, createIntlCache } from 'react-intl';

const intlCache = createIntlCache();
// eslint-disable-next-line import/prefer-default-export
export const createIntlFromRaw = (raw: { locale: string, message: any }) => createIntl(raw, intlCache);
